import type { GuestCountValue } from "../api/types";
import type { TFunc } from "../i18n";

export function isGuestCountValue(value: unknown): value is GuestCountValue {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false;
  const item = value as Record<string, unknown>;
  if (item.version !== 1) return false;
  if (item.kind === "range") return Number.isSafeInteger(item.lower) && Number.isSafeInteger(item.upper)
    && (item.lower as number) > 0 && (item.upper as number) >= (item.lower as number) && typeof item.approximate === "boolean";
  if (item.kind === "exact" || item.kind === "estimate") return Number.isSafeInteger(item.value) && (item.value as number) >= 0;
  return (item.kind === "lower_bound" || item.kind === "upper_bound") && Number.isSafeInteger(item.value)
    && (item.value as number) >= 0 && typeof item.inclusive === "boolean";
}

/** Render only the source statement; never calculate an effective count in the UI. */
export function guestCountText(value: GuestCountValue, t: TFunc): string {
  if (value.kind === "range") return `${value.approximate ? `${t("ws.count.approx")} ` : ""}${value.lower}–${value.upper}`;
  if (value.kind === "estimate") return `${t("ws.count.approx")} ${value.value}`;
  if (value.kind === "lower_bound") return `${value.inclusive ? "≥" : ">"} ${value.value}`;
  if (value.kind === "upper_bound") return `${value.inclusive ? "≤" : "<"} ${value.value}`;
  return String(value.value);
}

export function guestCountEditValue(kind: string, first: string, second: string, approximate: boolean, inclusive: boolean): GuestCountValue | null {
  if (!/^\d+$/.test(first)) return null;
  const value = Number(first);
  let result: GuestCountValue;
  if (kind === "range") {
    if (!/^\d+$/.test(second)) return null;
    result = { version: 1, kind, lower: value, upper: Number(second), approximate };
  } else if (kind === "lower_bound" || kind === "upper_bound") result = { version: 1, kind, value, inclusive };
  else if (kind === "exact" || kind === "estimate") result = { version: 1, kind, value };
  else return null;
  return isGuestCountValue(result) ? result : null;
}
